/** @format */

import * as React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { TICKET_STATUS } from 'src/constants';

export const ProgressBar = ({ data }) => {
  const { t } = useTranslation();
  return (
    <div className={`progress-bar progress-bar-${data.status ? data.status.replace(' ', '-') : ''}`}>
      <ul>
        <li className={`submitted ${data.status === TICKET_STATUS.new || !data.status ? 'active' : ''}`}>
          <p className="number">1</p>
          <p className="status">{t('Tickets.new')}</p>
          <p className="date">{format(new Date(data.createdon), 'dd.MM.yyyy hh:mm')}</p>
        </li>
        <li className={`in-progress ${data.status === TICKET_STATUS['in progress'] ? 'active' : ''}`}>
          <p className="number">2</p>
          <p className="status">{t('Tickets.inProgress')}</p>
        </li>
        <li className={`in-review ${data.status === TICKET_STATUS.pending ? 'active' : ''}`}>
          <p className="number">3</p>
          <p className="status">{t('Tickets.pending')}</p>
        </li>
        <li className={`resolved ${data.status === TICKET_STATUS.resolved ? 'active' : ''}`}>
          <p className="number">4</p>
          <p className="status">{t('Tickets.resolved')}</p>
          {data.closedon && <p className="date">{format(new Date(data.closedon), 'dd.MM.yyyy hh:mm')}</p>}
        </li>

        {data.status === TICKET_STATUS.cancelled ? (
          <li className={`cancelled ${data.status === TICKET_STATUS.cancelled ? 'active' : ''}`}>
            <p className="number">5</p>
            <p className="status">{t('Tickets.cancelled')}</p>
          </li>
        ) : (
          <li className={`closed ${data.status === TICKET_STATUS.closed ? 'active' : ''}`}>
            <p className="number">5</p>
            <p className="status">{t('Tickets.closed')}</p>
          </li>
        )}
      </ul>
    </div>
  );
};
